module.exports = __webpack_public_path__ + "files/7ec2e1bc8de62f96479987929c598f4b.png";